// @ts-nocheck
import * as sessionActions from '../actions/session.actions';

const initialStore = {
  currentSession: null
};

const actionsMap = {
  [sessionActions.SET_CURRENT_SESSION]: (store, action) => {
    const { session } = action.data;
    return {
      ...store,
      currentSession: session
    };
  }
};

export default function reducer(store = initialStore, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(store, action) : store;
}
